import { syncDependency, type DependencySyncConfig } from "./dependency-sync";
import { authors } from "@/plugins/LocalForagePlugin";
import { authorsSyncKey } from "@/types/products/product-keys";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";
import type { AuthorApiResponse, Authors } from "@tmi/types/api/content-models";
import type { Author } from "@tmi/types/entities";

const config: DependencySyncConfig<Authors, AuthorApiResponse, Author> = {
    name: 'author',
    store: authors,
    syncKey: authorsSyncKey,
    throttle: { hours: 4 },
    queryId: '95c537b081ea7ea3ccfbbb34f257bfd4',
    pageSize: 25,
    extractPayload: ( response: ApiFetchResponse<Authors> ) => response?.data?.authorCatalog?.authors,
    mapItem: ( a: AuthorApiResponse ): Author => ( {
        id: a.id,
        publishedAt: a.publish_at,
        name: a.name,
        pictureUri: a.pic_uri,
        biography: a.bio,
        shortBiography: a.short_bio,
        slug: a.slug
    } )
};

export function mapAuthorApiResponseToAuthorCatalog( response: ApiFetchResponse<Authors> ): Author[] {
    const raw = config.extractPayload( response );
    return raw ? raw.map( config.mapItem ) : [];
}

export async function loadAuthorMap( authorsMap: Map<string, Author> ): Promise<boolean> {
    return syncDependency( config, authorsMap );
}
